import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CASE_UPGRADE_ACTIONS } from "constants";
import {
    proceedCase,
    referCase,
    rejectCase,
    assignCase,
    reassignCase,
    holdCase,
    openHoldCase,
    requestDocuments
} from "actions";
import {
    fetchDesisioningDashboardProceed,
    fetchDesisioningDashboardRefer,
    fetchDesisioningDashboardSanction
} from "../modules/decision-dashboard/actions";
import { CaseActionModals, SanctionConditionModal } from "templates";

class CaseActionsView extends React.Component {
    takeCaseAction = (action, caseTaskId, caseId, data, stageName, stageId, stageType, path) => {
        const {
            proceedCase,
            rejectCase,
            referCase,
            assignCase,
            reassignCase,
            holdCase,
            openHoldCase,
            fetchDesisioningDashboardProceed,
            fetchDesisioningDashboardRefer,
            fetchDesisioningDashboardSanction
        } = this.props;
        const {
            page,
            pageSize,
            filters,
            current_stage
        } = this.props.location.state.case_actions;
                switch (action) {
        case CASE_UPGRADE_ACTIONS.BULK_SANCTION:
            fetchDesisioningDashboardSanction(
                this.props.location.state.case_actions.case_ids,
                data,
                page,
                pageSize,
                filters,
                current_stage
            );
            this.props.history.replace(this.props.location.pathname, {
                ...this.props.location.state,
                case_actions: {},
                disableActionButton: false
            });
            break;
        case CASE_UPGRADE_ACTIONS.BULK_PROCEED:
            fetchDesisioningDashboardProceed(
                this.props.location.state.case_actions.case_task_ids,
                data.stageId,
                data.userId,
                data.remarks,
                page,
                pageSize,
                filters,
                current_stage
            );
            break;
        case CASE_UPGRADE_ACTIONS.BULK_REFER:
            fetchDesisioningDashboardRefer(
                this.props.location.state.case_actions.case_task_ids,
                data.stageId,
                data.userId,
                data.remarks,
                page,
                pageSize,
                filters,
                current_stage
            );
            break;
        case CASE_UPGRADE_ACTIONS.PROCEED:
            proceedCase(
                caseTaskId,
                caseId,
                data.stageId,
                data.userId,
                data.remarks,
                stageName,
                stageId,
                typeof caseId === "object"
            );
            break;
        case CASE_UPGRADE_ACTIONS.PROCEED_BULK_CASES:
            proceedCase(
                caseTaskId,
                caseId,
                data.stageId,
                data.userId,
                data.remarks,
                stageName,
                stageId,
                true
            );
            break;
        case CASE_UPGRADE_ACTIONS.REJECT:
            rejectCase(
                caseId,
                data && data.reason,
                data && data.remarks ? data.remarks : "",
                stageName,
                stageId,
                typeof caseId === "object"
            );
            break;
        case CASE_UPGRADE_ACTIONS.REFER:
            referCase(
                caseTaskId,
                data.stageId,
                data.userId,
                data.remarks,
                data.reason,
                stageName,
                stageId,
                data.reasonId,
                data.subCategoryId,
                typeof caseId === "object",
                data.refer_reasons
            );
            break;
        case CASE_UPGRADE_ACTIONS.HOLD:
            holdCase(
                caseId,
                data && data.hold_remarks ? data.hold_remarks : "",
                data && data.action_reason,
                stageName,
                stageId,
                stageType
            );
            break;
        case CASE_UPGRADE_ACTIONS.OPEN:
            openHoldCase(
                caseId,
                data && data.open_remarks ? data.open_remarks : "",
                stageName,
                stageId,
                stageType
            );
            break;
        case CASE_UPGRADE_ACTIONS.PULL_BACK_TO_PS_KIT:
            referCase(
                caseTaskId,
                11,
                data.userId,
                data.remarks,
                data.reason,
                stageName,
                stageId,
                null,
                null,
                typeof caseId === "object",
                data.refer_reasons
            );
            break;
        case CASE_UPGRADE_ACTIONS.ASSIGN:
            assignCase(caseTaskId, data.userId, data.remarks, stageName, stageId, stageType, path, caseId);
            break;
        case CASE_UPGRADE_ACTIONS.REASSIGN:
            reassignCase(caseTaskId, data.userId, data.remarks, stageName, stageId, stageType, path, caseId);
            break;
        
        default:
            return null;
        }
    };

    resetState = () => {
        this.props.history.replace(this.props.location.pathname, {
            ...this.props.location.state,
            case_actions: {},
            disableActionButton: false
        });
    }

    render() {
        const { location, history } = this.props;
        if(location.state && location.state.case_actions && location.state.case_actions.action === CASE_UPGRADE_ACTIONS.BULK_SANCTION){
            return (
                <SanctionConditionModal
                    sanctionArray={
                        location.state &&
                        location.state.case_actions &&
                        location.state.case_actions.sanction_array
                    }
                    sanctionLimit={
                        location.state &&
                        location.state.case_actions &&
                        location.state.case_actions.proposed_limit                    
                    }
                    caseId={
                        location.state &&
                        location.state.case_actions &&
                        location.state.case_actions.case_id
                    }
                    caseIds={
                        location.state &&
                        location.state.case_actions &&
                        location.state.case_actions.case_ids
                    }
                    action={
                        location.state &&
                        location.state.case_actions &&
                        location.state.case_actions.action
                    }
                    location={location}
                    history={history}
                    upgradeCase={this.takeCaseAction}
                    resetState={this.resetState}
                />
            );
        }
        return (
            <CaseActionModals
                caseId={
                    location.state &&
                    location.state.case_actions &&
                    location.state.case_actions.case_id
                }
                caseIds={
                    location.state &&
                    location.state.case_actions &&
                    location.state.case_actions.case_ids
                }
                companyId={
                    location.state &&
                    location.state.case_actions &&
                    location.state.case_actions.companyId
                }
                associates={
                    location.state &&
                    location.state.case_actions &&
                    location.state.case_actions.associates
                }
                requestDocuments={this.props.requestDocuments}
                caseTaskIds={
                    location.state &&
                    location.state.case_actions &&
                    location.state.case_actions.case_task_ids
                }
                caseTaskId={
                    location.state &&
                    location.state.case_actions &&
                    location.state.case_actions.case_task_id
                }
                stageId={
                    location.state &&
                    location.state.case_actions &&
                    location.state.case_actions.stage_id
                }
                stageName={
                    location.state &&
                    location.state.case_actions &&
                    (location.state.case_actions.stage_name ||
                        location.state.case_actions.stageName)
                }
                action={
                    location.state &&
                    location.state.case_actions &&
                    location.state.case_actions.action
                }
                location={location}
                history={history}
                upgradeCase={this.takeCaseAction}
                selectedCasesType={
                    location.state &&
                    location.state.case_actions && 
                    location.state.case_actions.selectedCasesType
                }
            />
        );
    }
}

CaseActionsView.propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
    // user: PropTypes.object,
    stages: PropTypes.object,
    //Case Actions
    assignCase: PropTypes.func,
    reassignCase: PropTypes.func,
    proceedCase: PropTypes.func,
    referCase: PropTypes.func,
    rejectCase: PropTypes.func,
    selectedCasesType: PropTypes.string,
    holdCase: PropTypes.func,
    openHoldCase: PropTypes.func,
    fetchDesisioningDashboardProceed: PropTypes.func,
    fetchDesisioningDashboardRefer: PropTypes.func,
    fetchDesisioningDashboardSanction: PropTypes.func,
    requestDocuments: PropTypes.func,
};

const mapStateToProps = state => ({
    // user: state.user,s
    stages: state.stages
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            proceedCase,
            referCase,
            rejectCase,
            assignCase,
            reassignCase,
            holdCase,
            openHoldCase,
            fetchDesisioningDashboardProceed,
            fetchDesisioningDashboardRefer,
            fetchDesisioningDashboardSanction,
            requestDocuments
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CaseActionsView);
